<template>
  <!--
    我的订单：4 个口径页签
    我负责的（sceneType=1）/ 我下属负责的（sceneType=3）/
    别人分配给我的（assignedToMe）/ 我分配给别人的（assignedByMe）
  -->
  <OrderList :tabs="true" />
</template>

<script lang="ts" setup>
import OrderList from '../components/OrderList.vue'

defineOptions({ name: 'CrmOrderMy' })
</script>
